// Global constants for the frontend

export const DEFAULT_ACADEMIC_YEAR = 'AY202627';
// Exam-specific category configurations
const JEE_COMMON = {
    categories: ['OPEN', 'OBC-NCL', 'SC', 'ST', 'GEN-EWS'],
    specialCategories: ['PWD'],
    genderOptions: ['GENDER-NEUTRAL', 'FEMALE'],
  };
  export const examConfigurations = {
    'MHTCET': {
      categories: ['GENERAL', 'OBC', 'VJ(DT)/NTA', 'NT2/NTB','NT3/NTC', 'SC', 'ST', 'SEBC'],
      specialCategories: ['PWD', 'DEF', 'ORPHAN', 'TFWS', 'EWS'],
      genderOptions: ['GENERAL', 'LADIES', 'OTHER'],
    },
    'JEEADVANCED': JEE_COMMON,
    'JEEMAINS': JEE_COMMON,
    'COMEDK': {
      categories: ['GM', 'HKR/KKR'],
      specialCategories: [],
      genderOptions: [],
    },
  };


